import type { VaultDocument } from './vault-api';

/**
 * Vault display formatters (SCRUM-379) — mirror the v7 prototype's helpers
 * (vaultFileExt / vaultExtColor / size + date rendering in VAULT_FILES).
 */

/** Lower-cased file extension — `vaultFileExt` in the prototype. */
export function fileExt(name: string): string {
  const parts = name.split('.');
  return parts.length > 1 ? (parts.pop() ?? '').toLowerCase() : '';
}

/**
 * Ext badge color classes — the v7 `vaultExtColor` map: pdf=danger,
 * xlsx=success, pptx=warning, everything else indigo. Backgrounds use the
 * 10% color-mix the prototype applies.
 */
export function extBadgeClasses(ext: string): string {
  switch (ext) {
    case 'pdf':
      return 'text-danger bg-danger/10';
    case 'xlsx':
      return 'text-success bg-success/10';
    case 'pptx':
      return 'text-warning bg-warning/10';
    default:
      return 'text-accent-indigo bg-accent-indigo/10';
  }
}

/** "1.8 MB" / "340 KB" — the prototype's size string; URL refs render "URL". */
export function formatSize(doc: Pick<VaultDocument, 'sizeBytes' | 'source'>): string {
  if (doc.source === 'url') return 'URL';
  if (doc.sizeBytes > 1_048_576) return `${(doc.sizeBytes / 1_048_576).toFixed(1)} MB`;
  return `${String(Math.max(1, Math.round(doc.sizeBytes / 1024)))} KB`;
}

/** "Jan 15, 2026" — the prototype's upload-date format. */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
